import merge from 'lodash/merge';

import { SET_LEFT_MENU } from './left-menu-actions';

const NULL_SLUG_INFO = {
	active: false
};
const SlugInfoReducer = (state = NULL_SLUG_INFO, { type , active }) => {
	Object.freeze(state);
	switch(type) {
		case SET_LEFT_MENU:
			return merge({},state,{ active });
		default:
			return state;
	}
};

export default SlugInfoReducer;
